<template>
    <div class="card card-body mx-3 mx-md-4 mt-n1">
      <div class="row gx-4">  
        <div class="col-auto my-auto">
          <div class="h-100">
            <h4 class="mb-1">Come funziona?</h4>
          </div>
        </div>
        <div class="mt-4">
            test
        </div>
      </div>
    </div>
</template>
  
<script>
  export default {
    name: "HowItWorks",
  };
</script>
  